import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../../constants/VisitorActionTypes';
import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { EVENT_NAMES } from '../../usage-tracking/constants/eventNames';
export const clickedMeetingsLinkAction = createAction(ActionTypes.CLICKED_MEETINGS_LINK);
export function clickedMeetingsLink() {
  return dispatch => {
    dispatch(clickedMeetingsLinkAction());
    dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: 'clicked meeting link'
    }));
  };
}